import JwtPayload from '@/entities/api/jwt'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AuthSlice {
	token: string | null
	id: string | null
	data: JwtPayload | null
}

const initialState: AuthSlice = {
	token: null,
	id: null,
	data: null,
}

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		login: (
			state,
			action: PayloadAction<{
				token: string
				id: string
				data: JwtPayload
			}>
		) => {
			state.token = action.payload.token
			state.id = action.payload.id
			state.data = action.payload.data
		},
		updateUserData: (state, action: PayloadAction<any>) => {
			state.data = {
				...state.data,
				...action.payload,
			}
		},
		logout: (state) => {
			state.token = null
			state.id = null
			state.data = null
		},
	},
})

export const { login, updateUserData, logout } = authSlice.actions

export default authSlice.reducer
